import React from 'react';
import { workFormats } from '../data/materials';
export function WorkFormatSection() {
  return <section className="py-10 px-4 bg-gray-50" data-id="element-190" data-mp="3ig7cugmjtmpo">
      <div className="max-w-4xl mx-auto" data-id="element-191" data-mp="3iewbsokhmt29">
        <div className="text-center mb-8" data-id="element-192" data-mp="3n7phbens65fe">
          <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] leading-tight mb-2" data-id="element-193" data-mp="3n7z7p3cqmelm">
            NO SON 162 PÁGINAS PARA LEER.
            <br data-id="element-194" data-mp="2uirxv87u22l2" />
            <span className="text-[#157C8B]" data-id="element-195" data-mp="2ujbgkr5b4v05">
              SON 162 PÁGINAS PARA TRABAJAR.
            </span>
          </h2>
          <p className="text-gray-600" data-id="element-196" data-mp="2ziweqzcnkzbt">
            Cada tema está pensado para que el alumno pueda:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-197" data-mp="33i59a6fip18f">
          {workFormats.map(format => <div key={format.title} className="flex flex-col bg-white border border-gray-200 rounded-2xl p-5" data-id="element-198" data-mp="38ggjwjdmzfrp">
              <span className="text-2xl mb-2" aria-hidden="true" data-id="element-199" data-mp="ivlhz47so99c">
                {format.emoji}
              </span>
              <h3 className="text-base font-black text-[#14356B] mb-1" data-id="element-200" data-mp="1bv4nn1qdp7mu">
                {format.title}
              </h3>
              <p className="text-base text-gray-700 mt-auto" data-id="element-201" data-mp="16w1qs4kjy7py">
                {format.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}